import { alpha, darken, lighten, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    nodeWrapper: {
        width: 160,
        height: 160,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    node: {
        width: 48,
        height: 48,
        position: 'relative',
        borderRadius: '50%',

        '&:hover': {
            cursor: 'pointer',
        },

        '& .react-flow__handle': {
            position: 'absolute',
            opacity: 0,
            cursor: 'pointer',
        },

        '& .react-flow__handle-left': {
            left: 0,
        },

        '& .react-flow__handle-right': {
            right: 0,
        },

        '& .reactflow__edge': {
            cursor: 'default',
        },
    },
    hopNode: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `4px solid ${
            theme.palette.type === 'light'
                ? darken(alpha(theme.palette.divider, 1), 0.85)
                : lighten(alpha(theme.palette.divider, 1), 0.85)
        }`,
        backgroundColor:
            theme.palette.type === 'light'
                ? darken(theme.palette.background.paper, 0.02)
                : lighten(theme.palette.background.paper, 0.05),
    },
    hopNodeTopContent: {
        position: 'absolute',
        top: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',

        '& .MuiTypography-body2': {
            textAlign: 'center',
            fontSize: 24,
            fontWeight: 500,
            letterSpacing: 1.2,
        },
    },
    hopNodeBottomContent: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: 112,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        whiteSpace: 'break-spaces',

        '& .MuiTypography-body1': {
            backgroundColor: theme.palette.background.paper,
            textAlign: 'center',
            fontSize: 24,
            fontWeight: 800,
            letterSpacing: 1.2,
        },

        '& .MuiTypography-body2': {
            backgroundColor: theme.palette.background.paper,
            textAlign: 'center',
            fontSize: 20,
            fontWeight: 600,
            letterSpacing: 1.2,
        },

        '@media printing': {
            boxShadow: 'none',
        },
    },
    unidentifiableHopNode: {
        border: `4px dotted ${
            theme.palette.type === 'light'
                ? darken(alpha(theme.palette.divider, 1), 0.85)
                : lighten(alpha(theme.palette.divider, 1), 0.85)
        }`,
        backgroundColor: 'transparent',
    },
    infoText: {
        maxWidth: 176,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
}));
